import './ShadedText.scss';

type ShadedTextProps = {
  text: string;
};

/**
 * ShadedText renders a bit of text in inverse colors so that it stands out.
 */
function ShadedText({
  text,
}: ShadedTextProps): JSX.Element | null {
  return text ? <span className="ShadedText">{text}</span> : null;
}

export default ShadedText;
